











































































import { Component, Mixins, Prop } from "vue-property-decorator";
import ExpansionPanel from "../ui/ExpansionPanel.vue";
import MonthPicker from "../ui/MonthPicker.vue";
import { ReportsModule } from "@/store/reports.module";
import FormValidator from "@/mixins/FormValidator";
import { ReportAction } from "~/services/report";
import moment from "moment";

const PATH = "ReconciliationReport.prpt";

@Component({
  components: { ExpansionPanel, MonthPicker },
  watch: {
    to: "validateForm",
  },
})
export default class ReportForms extends Mixins(FormValidator) {
  @Prop({ default: false })
  readonly isDefault: boolean;

  from = "";
  to = "";
  max = moment().format("YYYY-MM-DD");
  min = ""; //???  минимальный период формирования не указан в эпике. Уточнить у Олеси.

  formRef = "form";

  get title() {
    return this.$t("reportsInfo.reconciliation-report.title") as string;
  }

  async generate(action: ReportAction) {
    if (!this.validateForm()) return;
    await ReportsModule.generateReport({
      action: action,
      path: PATH,
      type: "pdf",
      filename: this.title,
      query: {
        iContractId: this.$route.params.id,
        dtDataBegin: this.from.replace("-", "") + "01",
        dtDataEnd: moment(this.to + "-01")
          .endOf("month")
          .format("YYYYMMDD"),
      },
    });
  }

  validateDates() {
    if (!this.from) return true;
    if (moment(this.from).isAfter(this.to))
      return this.$t("reportsInfo.initial_period_later_than_final");
    else return true;
  }
}
